import * as React from 'react'

// libs
import { createUseStyles } from "react-jss";

// context
import { useStreamContext } from "../context"

// hooks
import useStreamActions from '../hooks.stream/useStreamActions'

// rsiute
import { Button } from 'rsuite';
import SpinnerIcon from '@rsuite/icons/legacy/Spinner';
import PlayOutlineIcon from '@rsuite/icons/PlayOutline';

const useStyles = createUseStyles({
  rootDiv: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,

    zIndex: 10,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    padding: '3rem',
    '& > *': {
      pointerEvents: 'all'
    }
  },
  webrtcError: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > h5': {
      textAlign: 'center',
      marginBottom: '1rem',
    }
  }
})

const Preloader = ({ show }: { show: boolean }) => {

  // hooks
  const streamContext = useStreamContext()
  const streamActions = useStreamActions()

  // render
  const showPlayButton = streamContext.state.webrtcStatus == 'connected'

  if (!show) return null

  if (showPlayButton) {
    return (
      <PlayOutlineIcon
        onClick={(event) => {
          event.preventDefault()
          event.stopPropagation()
          streamActions.play()
        }}
        style={{
          color: '#fff',
          fontSize: '10em',
          cursor: 'pointer',
        }} />
    )
  }

  return (
    <SpinnerIcon pulse style={{
      color: '#fff',
      fontSize: '3em'
    }} />
  )
}

const WebrtcError = ({ show }: { show: boolean }) => {

  // styles
  const styles = useStyles();

  // context
  const streamContext = useStreamContext()

  // hooks
  const streamActions = useStreamActions()

  // render
  if (!show) return null

  return (
    <div className={styles.webrtcError}>
      <h5>
        {streamContext.state.webrtcMessage}
      </h5>
      <Button
        onClick={() => {
          streamActions.reconnect()
        }}
        appearance='primary'>
        Restart
      </Button>
    </div>
  )
}

export default function View() {

  // styles
  const styles = useStyles();

  // hooks
  const streamContext = useStreamContext()
  const streamActions = useStreamActions()

  // render
  if (streamContext.isStreamActive) return null

  const isWebrtcError = streamContext.isWebrtcError

  return (
    <div className={styles.rootDiv}>

      <WebrtcError show={isWebrtcError} />
      <Preloader show={!isWebrtcError} />

    </div>

  )
}